import React from "react";
import Navbar from "./layout/Navbar";
import Footer from "./layout/Footer";
import CartSheet from "./CartSheet";
import WhatsAppButton from "./WhatsAppButton";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen bg-[color:var(--ms-ivory)] text-[color:var(--ms-charcoal)] flex flex-col">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
            <CartSheet />
            <WhatsAppButton />
        </div>
    );
}
